import GTrialCtaFooter from './g-trial-cta-footer.vue';

export default GTrialCtaFooter;
